import {inject,} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {LANDING_ROUTE} from "src/app/app-routing.module";
import {RaceService} from "@services";
import {FetchRaceByIdRequest, Race} from "@model";

export const RaceDetailsPublicResolver: ResolveFn<Observable<Race | null> | Race> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   raceService: RaceService = inject(RaceService),
   router: Router = inject(Router)): Observable<Race | null> | Race => {
    let raceId = route.queryParams["raceId"];
    if (!raceId) {
      router.navigate([LANDING_ROUTE]);
      return EMPTY;
    } else {
      return raceService.findRaceById(
        new FetchRaceByIdRequest(+raceId))
        .pipe(
          take(1),
          mergeMap((res: Race | null) => {
            if (res) {
              return of(res);
            } else {
              router.navigate([LANDING_ROUTE]);
              return EMPTY;
            }
          })
        );
    }
  }
